export const icons = [
  {
    species: "Dog",
    icon: "fa-dog", // Font Awesome Dog icon
  },
  {
    species: "Cat",
    icon: "fa-cat", // Font Awesome Cat icon
  },
  {
    species: "Fish",
    icon: "fa-fish", // Font Awesome Fish icon
  },
  {
    species: "Bird",
    icon: "fa-dove", // Font Awesome Dove icon (for a bird)
  },
  {
    species: "Ban",
    icon: "fa-ban", // Font Awesome Dove icon (for a bird)
  },
];


//Maybe use this
//https://lucide.dev/icons/?search=animal
